import gsap from "gsap";
import DefaultBlock from "/scripts/default/block";
import { watchPreferredMotion } from "../../../../../utils/helpers/watchPreferredMotion";
import { Draggable } from "gsap/Draggable";
import debounce from "lodash.debounce";
import { InertiaPlugin } from "gsap/InertiaPlugin";

gsap.registerPlugin(Draggable, InertiaPlugin);

export default class UIRange extends DefaultBlock {
	init() {
		this.DOM = {
			input: this.block.querySelector("#ui-range-input"),
			track: this.block.querySelector("#ui-range-track"),
			thumb: this.block.querySelector("#ui-range-thumb"),
			marker: this.block.querySelector("#ui-range-marker"),
			value: this.block.querySelector("#ui-range-value"),
			progress: this.block.querySelector("#ui-range-progress"),
		};

		this.buildOn();
		this.setupDrag();

		this.setMarkerScaleTo = gsap.quickSetter(this.DOM.marker, "css");
		this.setMarkerScale = (val) => {
			const scaledValue = gsap.utils.mapRange(1, 100, 1, 1.8, val);

			this.setMarkerScaleTo({ scaleX: scaledValue, scaleY: scaledValue });
		};
		this.setMarkerRotation = gsap.utils.pipe(
			gsap.utils.clamp(-500, 500),
			gsap.utils.mapRange(-500, 500, -45, 45),
			gsap.quickTo(this.DOM.marker, "rotation", {
				duration: 1.2,
				ease: "elastic.out(1.5, 0.4)",
			})
		);
	}

	setMarkerValue(val) {
		this.DOM.value.innerText = val;
	}

	setProgressX(x) {
		gsap.set(this.DOM.progress, { x });
	}

	setThumbX(x) {
		gsap.set(this.DOM.thumb, { x });
	}

	setupDrag() {
		const self = this;
		this.minBound = () => 0;
		this.maxBound = () =>
			this.DOM.track.clientWidth - this.DOM.thumb.clientWidth + 2;

		this.draggable = Draggable.create(this.DOM.thumb, {
			type: "x",
			bounds: {
				minX: self.minBound(),
				maxX: self.maxBound(),
			},
			edgeResistance: 1,
			onDrag: function () {
				const velocity = InertiaPlugin.getVelocity(this.target, "x");
				const value = Math.ceil(
					gsap.utils.mapRange(self.minBound(), self.maxBound(), 1, 100, this.x)
				);

				if (this.timeout) {
					clearTimeout(this.timeout);
				}

				this.timeout = setTimeout(() => {
					self.setMarkerRotation(0);
				}, 100);

				self.setProgressX(this.x);
				self.setMarkerValue(value);
				self.setMarkerScale(value);
				self.setMarkerRotation(-velocity);
			},
			onDragEnd: function () {
				self.setMarkerRotation(0);
				self.DOM.input.value = Number(self.DOM.value.innerText);
			},
		});
	}

	handleInput(e) {
		const value = e.target.value;
		const progressX = gsap.utils.mapRange(
			1,
			100,
			this.minBound(),
			this.maxBound(),
			value
		);

		this.setProgressX(progressX);
		this.setThumbX(progressX);
		this.setMarkerValue(value);
		this.setMarkerScale(value);
	}

	handleResize() {
		this.draggable[0].applyBounds({
			minX: this.minBound(),
			maxX: this.maxBound(),
		});
	}

	initEvents() {
		this.DOM.input.addEventListener("input", this.handleInput.bind(this));

		window.addEventListener(
			"resize",
			debounce(() => this.handleResize(), 200)
		);
	}

	buildOn() {
		gsap.set(this.block, { autoAlpha: 1 });

		watchPreferredMotion(() => {
			gsap
				.timeline({
					id: "ui-range-build-on",
					scrollTrigger: {
						trigger: this.block,
						start: "top 85%",
					},
				})
				.from(this.DOM.track, {
					scale: 0,
					duration: 0.2,
					ease: "power4.out",
				})
				.from(this.DOM.progress, {
					x: this.DOM.track.clientWidth - this.DOM.track.clientHeight,
					duration: 0.6,
					ease: "bounce.out",
				})
				.from(this.DOM.marker, {
					scale: 0,
					y: 8,
					duration: 0.2,
					ease: "power4.out",
				});

			// GSDevTools.create();
		});
	}
}
